export type LocaleConfiguration = {
	defaultLocale: string
	localeOptions: Array<string>
}

export const legacyLocaleConfiguration: LocaleConfiguration = {
	defaultLocale: 'en-DK',
	localeOptions: ['da-DK', 'en-DK'],
}

export const getLocaleConfiguration = (country: string | undefined): LocaleConfiguration | null => {
	if (!country) return legacyLocaleConfiguration

	if (country.toLowerCase() === 'dk')
		return {
			defaultLocale: 'da-DK',
			localeOptions: ['da-DK', 'en-DK'],
		}

	if (country.toLowerCase() === 'se')
		return {
			defaultLocale: 'sv-SE',
			localeOptions: ['sv-SE', 'en-SE'],
		}

	return null
}
